import FormField from "../form-field";
import RatingBar from "../../../rating-bar";

export default class RatingField extends FormField {
	constructor(props) {
		super(props);

		this.ratingBar = null;

		this.init();
	}

	init() {
		if (this.$root == null) {
			throw new Error('RatingField: Root element is not defined!');
		}

		const $ratingBar = this.$root.querySelector('.rating-bar');
		this.ratingBar = new RatingBar({ $root: $ratingBar });

		super.init();
	}

	addEventListeners() {
		this.ratingBar.subscribe('valueChange', ({ detail }) => {
			this.setValue(detail);
			this.validateSoft();
		});

		super.addEventListeners();
	}

	validate() {
		this.isValid = this.value !== null;
	}

	setInitialState() {
		this.setValue(null);
		this.validateSoft();
		this.ratingBar.dropState();
	}
}